/**
 * Isofin Announcement Bar - Performance-Optimized v2.0
 * =====================================================
 * Performance-Optimierungen:
 * - requestIdleCallback Init (verschiebt Init nach LCP)
 * - MutationObserver statt setInterval (kein CPU-Poll)
 * - Throttled Resize (150ms)
 * - Passive Event Listeners
 */

(function () {
  'use strict';

  var docEl = document.documentElement;
  var body = document.body;

  // Header-Selektoren (Priorität: sticky > standard > fallback)
  var headerSelectors = [
    '.shopify-section-header-sticky',
    '.shopify-section-header',
    '.header-wrapper',
    'header[role="banner"]'
  ];

  var bar = null;
  var headerEl = null;
  var resizeThrottle = null;

  /**
   * Sucht Header im DOM (erster Match gewinnt)
   */
  function findHeader() {
    for (var i = 0; i < headerSelectors.length; i++) {
      var el = document.querySelector(headerSelectors[i]);
      if (el) return el;
    }
    return null;
  }

  /**
   * v146: Wieder aktiv — wie in v139 (war dort kein CLS-Problem).
   * Aktualisiert --isofin-ab-height + setzt has-isofin-ab + isofin-push-header Klassen.
   * Mobile-CLS war in v139 trotz dieser Funktion = 0. Mein v145-Verdacht war falsch.
   */
  function applyOffsets() {
    if (!bar) return;
    var h = Math.ceil(bar.getBoundingClientRect().height) || 0;
    docEl.style.setProperty('--isofin-ab-height', h + 'px');
    if (!body.classList.contains('has-isofin-ab')) {
      body.classList.add('has-isofin-ab');
    }
    if (headerEl && !headerEl.classList.contains('isofin-push-header')) {
      headerEl.classList.add('isofin-push-header');
    }
  }

  /**
   * Throttled Wrapper für applyOffsets (150ms)
   */
  function throttledApplyOffsets() {
    clearTimeout(resizeThrottle);
    resizeThrottle = setTimeout(applyOffsets, 150);
  }

  /**
   * Hauptinitialisierung (läuft im Idle-Time)
   */
  function init() {
    // requestAnimationFrame für präzise Messung nach Paint
    requestAnimationFrame(function () {
      bar = document.querySelector('.isofin-ab-wrapper');
      headerEl = findHeader();

      if (bar) {
        applyOffsets();

        // ResizeObserver für Bar-Größenänderungen
        if ('ResizeObserver' in window) {
          var ro = new ResizeObserver(applyOffsets);
          ro.observe(bar);
        }
      }

      // MutationObserver für nachträglich eingefügte Header
      // WICHTIG: disconnect() sobald Header gefunden
      if ('MutationObserver' in window && !headerEl) {
        var mo = new MutationObserver(function () {
          if (!headerEl) {
            headerEl = findHeader();
            if (headerEl) {
              headerEl.classList.add('isofin-push-header');
              applyOffsets();
              mo.disconnect(); // Stoppt Observer nach Fund
            }
          }
        });
        mo.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    });
  }

  // Idle-Init: Verschiebt Init nach LCP (non-blocking)
  if ('requestIdleCallback' in window) {
    requestIdleCallback(init, { timeout: 100 });
  } else {
    // Fallback für Safari < 13
    setTimeout(init, 0);
  }

  // Passive Listener: Browser kann Scrolling optimieren
  window.addEventListener('resize', throttledApplyOffsets, { passive: true });
  window.addEventListener('orientationchange', throttledApplyOffsets, { passive: true });
})();
